import Vue from 'vue'
import Vuex from 'vuex'

import session from './session'
import code from './code'

Vue.use(Vuex)

const store = new Vuex.Store({
  // strict: true, // process.env.NODE_ENV !== 'production',
  // state    : session/state,
  // mutations: session/mutations,
  // actions  : session/actions,
  // getters  : session/getters,

  modules: {
    strict: process.env.NODE_ENV !== 'production',
    session,
    code,
  }
})

export default store
